/**
 * @ngdoc service
 * @name proximus.core.language.service:LanguageService
 * @description
 * # LanguageService
 *  Is used to provide the selected language
 */
export default class NetworkService {
    constructor(configurationService) {
        this.configurationService = configurationService;
        this._configurationService = this.configurationService;
    }
    isOnline() {
        return this._configurationService.isOnline();
    }
}
